/**
 * Acceso con clave a los planes PYME, PRO y PLUS mientras están ocultos de la web
 * (`MOSTRAR_PLANES_POS` en `planesPublicos.ts`).
 *
 * Ojo: es una puerta comercial, no seguridad. La clave va en el código del navegador y quien sepa
 * buscarla la encuentra; sirve para que esos planes no se vean a simple vista, no para protegerlos.
 * El desbloqueo dura lo que la pestaña (`sessionStorage`).
 */
import { MOSTRAR_PLANES_POS } from './planesPublicos';

/** Pantalla con la clave. Se llega desde el enlace discreto «Acceso privado» del footer. */
export const RUTA_PLANES_PRIVADOS = '/planes/empresas';

const CLAVE = 'contabi321';
const LLAVE_SESION = 'contabi:planes-privados';

export function planesPrivadosVisibles(): boolean {
  if (MOSTRAR_PLANES_POS) return true;
  try {
    return sessionStorage.getItem(LLAVE_SESION) === '1';
  } catch {
    return false;
  }
}

/** Devuelve si la clave es correcta y, si lo es, deja la pestaña desbloqueada. */
export function desbloquearPlanesPrivados(clave: string): boolean {
  if (clave.trim() !== CLAVE) return false;
  try {
    sessionStorage.setItem(LLAVE_SESION, '1');
  } catch {
    // Sin almacenamiento (modo privado estricto) se desbloquea igual, solo que no se recuerda.
  }
  return true;
}

/** A dónde vuelve quien sale del formulario de demostración. */
export function rutaVolverAPlanes(): string {
  return MOSTRAR_PLANES_POS ? '/planes' : RUTA_PLANES_PRIVADOS;
}
